import type { PostDataModel, PostModel } from '../../data-layer/posts/types';

export const toPostDataModel = (postModel: PostModel): PostDataModel => ({
    ...postModel,
    business: postModel.business ? postModel.business.publicId : undefined,
});
